module.exports = __webpack_public_path__ + "img/icon-pentung-grey.94a554c8.svg";